export const reportsArticles = [
    {
        id: 'reports.overview',
        title: 'Reports Overview',
        category: 'Reports',
        order: 1,
        summary: 'Generating and viewing system reports',
        content: `
The Reports page provides access to various reports for estimating, financial tracking, and project management.

**Report Categories:**

- **Estimating Reports** - BOQ summaries, price lists
- **Financial Reports** - Invoices, payments, budgets
- **Project Reports** - Job status, progress tracking

**Features:**

- Filter by date range and job
- Preview before printing
- Export to PDF or Excel
    `,
        expandableSections: [
            {
                title: 'Report List',
                content: `
Available reports include:

**Estimating:**
- BOQ Summary
- BOQ Detail
- Price List
- Cost Centre Summary

**Financial:**
- Aged Payables
- Aged Receivables
- Payment Summary
- Invoice Register

**Project:**
- Job Status Report
- Order Summary
- Commitment Report
        `,
            },
        ],
        keywords: ['reports', 'printing', 'export', 'summary'],
        route: '/reports',
        relatedArticles: ['reports.estimating', 'reports.financial'],
    },
    {
        id: 'reports.estimating',
        title: 'Estimating Reports',
        category: 'Reports',
        order: 2,
        summary: 'BOQ and pricing reports',
        content: `
Estimating reports provide summaries and details of your bills of quantities.

**Available Reports:**

- BOQ Summary - Cost centre totals
- BOQ Detail - Full line item listing
- Price Comparison - Compare prices across jobs
    `,
        expandableSections: [
            {
                title: 'BOQ Summary Report',
                content: `
Shows cost centre totals for a job:

1. Select **BOQ Summary** report
2. Choose the Job
3. Select Price Level
4. Set Bill Date
5. Click **Generate**

The report shows:
- Cost centre hierarchy
- Subtotals per section
- Bill total
        `,
            },
            {
                title: 'BOQ Detail Report',
                content: `
Shows all line items:

1. Select **BOQ Detail** report
2. Choose the Job
3. Set filters (cost centre, supplier)
4. Click **Generate**

Includes:
- Every line item
- Quantities and prices
- Extended values
- Cost centre organization
        `,
            },
        ],
        keywords: ['estimating reports', 'BOQ report', 'price list'],
        route: '/reports',
        relatedArticles: ['reports.overview', 'boq.overview'],
    },
    {
        id: 'reports.financial',
        title: 'Financial Reports',
        category: 'Reports',
        order: 3,
        summary: 'Invoice, payment, and budget reports',
        content: `
Financial reports help track payables, receivables, and budget performance.

**Available Reports:**

- Aged Payables - What you owe suppliers
- Aged Receivables - What clients owe you
- Budget vs Actual - Variance analysis
- Payment History - Past payments
    `,
        expandableSections: [
            {
                title: 'Aged Payables Report',
                content: `
Shows outstanding supplier invoices by age:

1. Select **Aged Payables**
2. Set "As At" date
3. Choose aging periods (30/60/90 days)
4. Click **Generate**

Report shows:
- Supplier name
- Current (not due)
- 30 days overdue
- 60 days overdue
- 90+ days overdue
- Total owing
        `,
            },
            {
                title: 'Budget vs Actual',
                content: `
Compare budgeted amounts to actual costs:

1. Select **Budget vs Actual**
2. Choose the Job
3. Select grouping (cost centre, supplier)
4. Click **Generate**

Shows:
- Budgeted amount
- Committed (ordered)
- Actual (invoiced)
- Variance
        `,
            },
        ],
        keywords: ['financial reports', 'aged payables', 'receivables', 'budget'],
        route: '/reports',
        relatedArticles: ['reports.overview', 'accounting.overview'],
    },
    {
        id: 'reports.export',
        title: 'Exporting Reports',
        category: 'Reports',
        order: 4,
        summary: 'Exporting reports to PDF and Excel',
        content: `
Export reports to different formats for sharing or further analysis.

**Export Formats:**

- **PDF** - For printing and sharing
- **Excel** - For further analysis
- **Print** - Direct to printer
    `,
        expandableSections: [
            {
                title: 'Exporting',
                content: `
After generating a report:

1. Click **Export** dropdown
2. Choose format:
   - PDF - Downloads PDF file
   - Excel - Downloads XLSX file
   - Print - Opens print dialog
3. File downloads automatically

**Email:**
1. Click **Email**
2. Enter recipient(s)
3. Add message
4. Send

Report attaches as PDF.
        `,
            },
        ],
        keywords: ['export', 'PDF', 'Excel', 'print', 'download'],
        route: '/reports',
        relatedArticles: ['reports.overview'],
    },
];
